module.exports = __webpack_public_path__ + "img/1924.cc57cdf3.svg";